import React from "react";
import "./header.css"

function Header() {
  return (
    <nav className="navbar navbar-dark bg-dark">
      <a className="navbar-brand" href="/">
       CYF - YouTube
      </a>
    </nav>
  );
}

export default Header;
